// SearchDeals.jsx
import { useState } from "react";
import DealsSearch from "../components/DealsSearch";
import PipelineDeals from "../components/PipelineDeals";
import { searchDeals } from "../api/api";
import { useTranslation } from "react-i18next";

export default function SearchDeals() {
  const [searchData, setSearchData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchResults, setSearchResults] = useState([]);
  const { t } = useTranslation();

  const handleSearchData = async (formData) => {
    // Reset states
    if (formData === null) {
      setSearchData(null);
      setSearchResults([]);
      setError(null);
      return;
    }

    try {
      setLoading(true);
      setError(null);
      
      // First get fresh data from API
      const allData = await searchDeals({ 
        // Pass minimal params to get all data
        page: 0,
        pageSize: 1000
      });

      if (!allData) {
        throw new Error("Failed to fetch data");
      }

      // Then filter the data based on search criteria
      let filteredResults = allData;

      // Apply filters based on formData
      if (formData.mortgageAccountNumber) {
        filteredResults = filteredResults.filter(item => 
          item.mortgageAccountNumber?.toLowerCase().includes(formData.mortgageAccountNumber.toLowerCase())
        );
      }

      if (formData.poS_System_ID) {
        filteredResults = filteredResults.filter(item => 
          item.poS_System_ID?.toLowerCase().includes(formData.poS_System_ID.toLowerCase())
        );
      }

      if (formData.primaryBorrowerName) {
        const searchName = formData.primaryBorrowerName.toLowerCase();
        filteredResults = filteredResults.filter(item => {
          const fullName = `${item.primaryBorrowerFirstName || ''} ${item.primaryBorrowerLastName || ''}`.toLowerCase();
          return fullName.includes(searchName);
        });
      }

      // Update states with filtered results
      setSearchData(formData);
      setSearchResults(filteredResults);
      
    } catch (error) {
      console.error("Error searching deals:", error);
      setError("Failed to fetch search results. Please try again.");
      setSearchResults([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="h-full w-full flex flex-col justify-normal items-start gap-2 p-5">
      <DealsSearch onSearch={handleSearchData} />
      
      {loading ? (
        <div className="w-full text-center p-5">Loading...</div>
      ) : error ? (
        <div className="w-full text-center p-5 text-red-500">{error}</div>
      ) : searchResults.length > 0 ? (
        <PipelineDeals 
          searchData={searchData} 
          apiEndpoint="/searchDeal"
          pageTitle="dealsSearch.SearchResults"
          initialData={searchResults}
        />
      ) : (
        <div className="w-full text-center p-5">
          {searchData ? t(`dealsSearch.noSearch`) : t(`dealsSearch.initSearch`)}
        </div>
      )}
    </section>
  );
}